// extracted by mini-css-extract-plugin
export default {"transactionHistory":"TransactionHistory_transactionHistory__h95cH","row":"TransactionHistory_row__8k8uo","cell":"TransactionHistory_cell__NX1hX"};